import Utils from './utils';
import Feat from './feat/feat';

export default class App {
  constructor(d) {

    this.data     = d;  //Data provided on-page via script tags
    this.state    = {}; //State used on this page
    this.store    = {}; //State shared between pages
    this.view     = {}; //Functions that display state
    this.mutator  = {}; //Functions that mutate state
    this.event    = {}; //Event listeners/publishers

    // Create event bus
    this.bus = new Vue();

    //Utility functions
    this.utils = new Utils(this);
    this.feat  = new Feat(this);
    
    // Create Vue instance
    this.vm = new Vue({
      el: '#app',
      data: {
        d:  this.data,
        s:  this.state,
        v:  this.view,
        m:  this.mutator,
        ls: this.store, //local storage
        bus:this.bus,
      },
      delimiters: ["{~","~}"],
      methods: {
        log: (log) => {
          console.log(log);
        },
        emit: (path, data={}) => {
          console.log('emit', path);
          this.bus.$emit(path, data);
        },
        instance: function() {
          return this;
        }
      }
    });

    this.bus.$emit('vue/loaded',{});
  
  }
}

window.app = new App(window._data);